// @flow
import getGeolocation from './getGeolocation'

/**
 * Returns country code based on user ip
 * @return {Promise} A resolved Promise with an user country code, US by default
 */
export const getGeoCountryCode = (): Promise<any> =>
  getGeolocation()
    .then((res) => res.country_code.toLowerCase())
    .catch(() => 'us')

export default getGeoCountryCode
